import React, {useState} from "react";
import {closePopup, getElementValue} from "../../utils/CommonUtils";
import closeV2 from "../../static/image/v2/popup/closeV2.png";
import {inputMaxLength, setValue} from "../../static/js/Common2";
import {getFreeImageApi} from "../../api/imageApi";
import {value} from "lodash/seq";

const LogoSearchPopup = ({ setIsLogoChanged }) => {
  const [list, setLIst] = useState([]);
  const [selectedId, setSelectedId] = useState(null);

  const handleSearchEvent = async () => {
    const getKeyword = getElementValue("searchInput");

    if (getKeyword.length >= 2) {
      const searchData1 = {
        page: 1,
        count: 50,
        searchKeyword: getKeyword,
        searchType: 2,
        type: 6,
        // type 6 = 로고
        // type 9 = product
        // type: 9,
      };
      const searchData2 = {
        page: 1,
        count: 50,
        searchKeyword: getKeyword,
        searchType: 1,
        type: 6,
      };

      try {
        const [response1, response2] = await Promise.all([
          getFreeImageApi(searchData1),
          getFreeImageApi(searchData2),
        ]);

        const combinedData = [
          ...(response1?.data || []),
          ...(response2?.data || []),
        ];

        setLIst(combinedData);
      } catch (error) {
        console.error("검색 중 오류 발생:", error);
      }
    } else {
      alert("검색어를 2자 이상 입력해주세요")
    }
  }

  const handleSelect = (id) => {
    setSelectedId(id); // 클릭한 id를 상태로 저장
  };

  const handleImageSelectEvent = () => {
    const logoPreview = document.getElementById("logoPreview");
    const imageData = list.find((value) => value.id === selectedId);
    logoPreview.setAttribute("src", imageData.imageUrl);
    logoPreview.setAttribute("data-id", selectedId);
    setIsLogoChanged(true);
    handleClose();
  }

  const handleClose = () => {
    setSelectedId(null);
    setLIst([]);
    setValue("searchInput", "");
    closePopup("logoSearchPopup");
  }

  return (
    <div className="popupV2 hide" id="logoSearchPopup">
      <div className="popupContainer width578">
        <div className="popupTitle">
          <h2>로고 이미지 검색</h2>
          <button className="closeBtn" onClick={handleClose}>
            <img src={closeV2} alt="취소" />
          </button>
        </div>
        <div className="popupContent">
          <div className='popupFlexBox popupFlexBox1'>
            <input
              id='searchInput' className="searchInput" name='searchInput' type='text'
              maxLength={30} onInput={(e) => inputMaxLength(e)}
              placeholder="프랜차이즈명으로 검색해주세요"
            />
            <button
              type="text"
              className="imageSearchBtn bg-blue fc-white ml-5"
              onClick={handleSearchEvent}
            >
              이미지 검색
            </button>
          </div>
          <div className="popupFlexBox searchTextBox">
            <span>※사용 전 꼭 확인해주세요!</span><br/>
            제공드리는 이미지는 저작권법에 따라 띵동 앱에서만 사용할 수 있어요 저작권 분쟁 발생 시 띵동에서는 책임지지 않아요
          </div>
          <div className="searchImageBox">
            {list.map((value, index) => {
              return (
                <div
                  data-id={value.id}
                  className={selectedId === value.id ? "active" : ""}
                  key={index}
                  onClick={() => handleSelect(value.id)}
                >
                  <img src={value.imageUrl} alt={value.name} />
                </div>
              )
            })}
          </div>

        </div>
        <div className='popupBtn'>
          <button type='button' className='closeBtn stopCloseBtn' onClick={handleClose}>취소</button>
          <button type='button' id="shopInfo1Btn" className='shopInfo1Btn blueBtn' onClick={handleImageSelectEvent}>확인</button>
        </div>
      </div>
    </div>
  )
}

export default LogoSearchPopup;